export default "__VITE_ASSET__CVNufWSF__"